/** Shared page container — fluid width with responsive horizontal padding. */
export const containerClassName =
  "w-full max-w-[1920px] mx-auto px-4 sm:px-6 md:px-8 lg:px-10 xl:px-14 2xl:px-20";
